
import {
    defineComponent,
    inject,
    ref
} from "vue"

//components
import itemFile from "../tramites/components/itemFile.vue"

//services
import Tramite from "@/core/services/TramiteService";
import {
    errManager
} from "@/core/config/Tools";

export default defineComponent({
    props: {
        expediente: Object
    },
    components: {
        itemFile
    },
    setup(props) {

        const loading = ref(false)
        const listFiles = ref([])
        const open_dialog_file_list = inject('open_dialog_file_list');

        const getFiles = async () => {
            loading.value = true
            await Tramite.Files(props.expediente)
                .then((res) => {
                    loading.value = false
                    listFiles.value = res.data
                }).catch(({
                    response
                }) => {
                    loading.value = false
                    errManager(response);
                })
        }

        const oonClosed = () => {
            listFiles.value = []
        }

        return {
            loading,
            open_dialog_file_list,
            listFiles,
            getFiles,
            oonClosed,
        }
    }
})
